import { INCOME_TIER_NONE } from '../../components/pricing-drawer/constants';

export type IncomeTierOptions = {
  rate: string;
  text: string;
  value: string;
};

const addNoRebateIncomeTier = (incomeTierOptions: IncomeTierOptions[]) => [
  ...incomeTierOptions,
  {
    text: 'I don’t want to claim the rebate',
    value: INCOME_TIER_NONE,
  },
];

export default addNoRebateIncomeTier;
